import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import { Grid, Typography } from "@mui/material";
import NewServiceCard from "../../NewServiceCard";
import SubservicePopup from "../../../../components/customPopup/SubservicePopup";
import TestPrepSubserviceComp from "./TestPrepSubserviceComp";
import SabSubserviceComp from "./SabSubserviceComp";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function SubSeriviceCards() {
  const userId = localStorage.getItem("userId");

  const [serviceLoading, setServiceLoading] = useState(false);
  const [subserviceData, setSubserviceData] = useState([]);
  const [testPrepLoading, setTestPrepLoading] = useState(false);
  const [testPrepSubservices, setTestPrepSubservices] = useState([]);
  const [openSubservicePopup, setOpenSubservicePopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  // Fetch Sub service data
  useEffect(() => {
    const fetchservice = async () => {
      try {
        setServiceLoading(true);
        const response = await fetch(
          `${API_ENDPOINT}stm-route/getservice/${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();

          // Attach firstImage and secondImage
          const updatedData = data.result.map((item, index) => {
            const imageMappings = {
              1: {
                firstImage: "/newdashboard/Sub service/Group 1000016418.png",
                secondImage:
                  "/newdashboard/Sub service/Frame 1597881727.png",

                background:
                  "linear-gradient(106.28deg, #FFFFFF 4.33%, #FFF6FE 95.44%)",
                textColor: "rgba(157, 3, 133, 1)",
              },
              2: {
                firstImage:
                  "/newdashboard/Sub service/Group 1000016418 (1).png",
                secondImage: "/newdashboard/Sub service/Frame 1597881728.png",
                background:
                  "linear-gradient(106.28deg, #FFFFFF 4.33%, #EEFFFA 95.44%)",
                textColor: "rgba(11, 105, 79, 1)",
              },
              // 👉 add more if needed
            };

            return {
              ...item,
              firstImage:
                imageMappings[item.id]?.firstImage ||
                "/newdashboard/default1.png",
              secondImage:
                imageMappings[item.id]?.secondImage ||
                "/newdashboard/default2.png",
              background: imageMappings[item.id]?.background,
              textColor: imageMappings[item.id]?.textColor,
            };
          });

          setSubserviceData(updatedData);
        } else {
          console.error("internal server error");
        }
      } catch (err) {
        console.error("internal server error", err);
      } finally {
        setServiceLoading(false);
      }
    };

    fetchservice();
  }, []);

  const fetchTestPrepSubservices = async (subserviceId) => {
    const formData = {
      sp_user_id: parseInt(userId),
      service_id: subserviceId,
    };
    try {
      setTestPrepLoading(true);
      const response = await fetch(`${API_ENDPOINT}stm-route/gettesttype`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        setTestPrepSubservices(data);
        handleOpenSubservicePopup(subserviceId);
      } else {
        console.error("internal server error");
      }
    } catch (err) {
      console.error("internal server error", err);
    } finally {
      setTestPrepLoading(false);
    }
  };

  const handleOpenSubservicePopup = (dataId) => {
    setOpenSubservicePopup(true);
    setSelectedId(dataId);
  };

  const handleCloseSubservicePopup = () => {
    setOpenSubservicePopup(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomCardWithBorder boxShadow={true} padding="10px">
            <Grid container spacing={2}>
              {serviceLoading ? (
                <Grid item xs={12}>
                  <Loader height="10vh" text="Loading Service..." />{" "}
                </Grid>
              ) : (
                subserviceData?.map((subservice) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    onClick={() => fetchTestPrepSubservices(subservice?.id)}
                   
                  >
                    <GlobalCard
                      hovershadowEffect={true}
                      cursor={true}
                      padding="0px"
                      height="100%"
                      background={subservice?.background}
                    >
                      <NewServiceCard
                        firstImage={subservice?.firstImage}
                        title={subservice?.service_name}
                        subtitle={subservice?.description}
                        secondImage={subservice?.secondImage}
                        onClick={() => fetchTestPrepSubservices(subservice?.id)}
                        textColor={subservice?.textColor}
                      />
                    </GlobalCard>
                  </Grid>
                ))
              )}
            </Grid>
          </CustomCardWithBorder>
        </Grid>
      </Grid>

      {selectedId === 1 && (
        <SubservicePopup
          handleClose={handleCloseSubservicePopup}
          component={
            <TestPrepSubserviceComp subserviceCardData={testPrepSubservices} />
          }
          open={openSubservicePopup}
          subtitle=""
          maxWidth="lg"
        />
      )}

      {selectedId === 2 && (
        <SubservicePopup
          handleClose={handleCloseSubservicePopup}
          component={
            <SabSubserviceComp subserviceCardData={testPrepSubservices} />
          }
          open={openSubservicePopup}
          subtitle=""
          maxWidth="md"
        />
      )}
    </>
  );
}
